import { Collection } from '@/state/Collection';
import { _POSTS } from "@/state";
import { _TENANT } from "@/state";

import { PostsRoutes } from '@/repository/resources';
const { GetAllPosts, GetPost, CreatePost, UpdatePost, DeletePost } = PostsRoutes;

import postLikes from './postLikes'

export default {
	namespaced: true,
	state: {
		all: Collection.stateDefaults(),
		_all: new Collection({ statePath: 'posts.all' })
	},
	modules: {
		postLikes
	},
	actions: {

		async load({ commit }, args) {
			if (_TENANT().blocked_apps.includes('social')) return;
			try {
				let { page } = Object.assign({ page: false }, args)
				let res = await GetAllPosts({ page });
				commit('SET_POSTS_LIST', res.data);
				return res
			}
			catch (error) {
				console.error('Posts could not be indexed.', error);
				throw error;
			}
		},

		async loadNextPage({ commit }) {
			if (_TENANT().blocked_apps.includes('social')) return;
			try {
				if (_POSTS().pagination.isLastPage()) {
					return;
				}
				let res = await GetAllPosts({ page: _POSTS().pagination.nextPage() })
				commit('APPEND_MULTIPLE_POSTS_TO_LIST', res.data);
				return res
			}
			catch (error) {
				console.error('Older posts could not be indexed.', error);
				throw error;
			}
		},

		async create({ commit, state }, post) {
			if (_TENANT().blocked_apps.includes('social')) return;
			let isComment = !!(post || {}).parent_id
			let type = isComment ? 'Comment' : 'Post'
			try {
				let res = await CreatePost({ post });
				commit((isComment ? 'ADD_COMMENT' : 'PREPEND_SINGLE_POST_TO_LIST'), res.data)
				return res
			}
			catch (error) {
				console.error(type + ' could not be created.', error);
				throw error;
			}
		},

		async show({ commit, dispatch }, { id }) {
			if (_TENANT().blocked_apps.includes('social')) return;
			try {
				let res = await GetPost({ post: id });
				commit('SET_POSTS_LIST', [res.data])
				return res
			}
			catch (error) {
				console.error('Post could not be indexed.', error);
				throw error;
			}
		},

		async update({ commit, state }, post) {
			if (_TENANT().blocked_apps.includes('social')) return;
			let isComment = !!(post || {}).parent_id
			let type = isComment ? 'Comment' : 'Post'
			try {
				let res = await UpdatePost({ post });
				commit('EDIT_POST', res.data)
				return res
			}
			catch (error) {
				console.error(type + ' could not be updated.', error);
				throw error;
			}
		},

		async delete({ commit, dispatch }, { post }) {
			if (_TENANT().blocked_apps.includes('social')) return;
			let isComment = !!(post || {}).parent_id
			let type = isComment ? 'Comment' : 'Post'
			try {
				let res = await DeletePost({ post });
				if (res.status !== 204) {
					throw 'Problem occurred when deleting post.';
				}
				commit('DELETE_' + (isComment ? 'COMMENT' : 'POST'), post)
				return true;
			}
			catch (error) {
				console.error(type + ' could not be deleted.', error);
				throw error;
			}

		}

	},
	mutations: {
		SET_POSTS_LIST(state, data) {
			state._all.items.set(data).commitToState()
		},
		PREPEND_MULTIPLE_POSTS_TO_LIST(state, objs) {
			state._all.items.prepends(objs).commitToState();
		},
		PREPEND_SINGLE_POST_TO_LIST(state, obj) {
			state._all.items.prepend(obj).commitToState();
		},
		APPEND_MULTIPLE_POSTS_TO_LIST(state, objs) {
			state._all.items.appends(objs).commitToState();
		},
		APPEND_SINGLE_POST_TO_LIST(state, obj) {
			state._all.items.append(obj).commitToState();
		},
		DELETE_POST(state, obj) {
			state._all.items.deleteItem(obj).commitToState();
		},
		EDIT_POST(state, obj) {
			state._all.items.updateItem(obj).commitToState();
		},
		ADD_COMMENT(state, data) {
			let parent = state._all.items.toArray().find(p => p.id == data.parent_id);
			if (parent) {
				parent.comments.unshift(data)
				state._all.items.updateItem(parent).commitToState();
			}
		},
		DELETE_COMMENT(state, data) {
			let parent = state._all.items.toArray().find(p => p.id == data.parent_id);
			if (parent) {
				parent.comments = parent.comments.filter(c => c.id != data.id);
				state._all.items.updateItem(parent).commitToState();
			}
		}
	}
}